const queryStrReader = str => {
    if (typeof str !== 'string')
        throw 'Not a String. String expected, passed: ' + typeof str + ' to queryStrReader.';
    if (str.length <= 1)
        return '';
    str = str.substring(1);
    let queryStringArr = str.split('&');
    let queryStringObj = {};
    for (let elem of queryStringArr) {
        let key, realKey, subKey, value;
        [key, value=''] = elem.split('=');
        if (key.match(/\[/)){
            [realKey, subKey] = key.split('[');
            if (!queryStringObj[realKey])
                queryStringObj[realKey] = {};
            subKey = subKey.slice(0, -1);
            queryStringObj[realKey][subKey] = decodeURIComponent(value);
        } else {
            queryStringObj[key] = decodeURIComponent(value);
        }
    }
    return queryStringObj;
};

export default queryStrReader;